<!-- The scrim the drawer shares (`.mscrim` under `html.mfilters-open`, P/Member_Hub.html:518, 520). -->
<div class="agu-sheet__scrim" [class.agu-sheet__scrim--open]="Open" (click)="RequestClose()" aria-hidden="true"></div>
<div #panel class="agu-sheet" [class.agu-sheet--open]="Open" role="dialog" aria-modal="true" [attr.aria-labelledby]="TitleId" tabindex="-1" [attr.inert]="Open ? null : ''" [attr.aria-hidden]="Open ? null : 'true'">
    <!-- `.msheethead` (P/Member_Hub.html:617-618, 901). -->
    <div class="agu-sheet__head">
        <span [id]="TitleId">Filters</span>
        <button #doneButton type="button" (click)="RequestClose()">Done</button>
    </div>
    <ng-content />
    <!-- `.msheetfoot` (P/Member_Hub.html:619-620, 902). -->
    <div class="agu-sheet__foot">
        <button type="button" (click)="RequestShowResults()">Show results</button>
    </div>
</div>
